/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * @desc app弹窗活动信息
 */
import { defaultSuccess, defaultError, http } from "@/plugins/axios";

export default async function (
  success: ({
    data,
    ext,
    state,
    errors,
  }: {
    data: good.AppPopupInfoDto;
    ext: ObjectMap;
    state: "SUCCESS" | "FAIL" | "EXCEPTION";
    errors?: Array<string>;
  }) => void = defaultSuccess,
  fail: (error: string) => void = defaultError
): Promise<void> {
  return http({
    method: "get",
    url: `/good/appPopupInfo`,
  })
    .then((data) => success(data as any))
    .catch((error) => fail(error));
}
